<template>
  <collapsible-section
      :id="`repeatable_collapse_${elementContainer.client_id}-${dropdownControlId}`"
      :control-name="`${elementContainer.referenceNameOrDefault}Collapse`"
      :is-open="isOpen(elementContainer.formElementsArray)"
  >
    <template #section-header>
      <icon v-if="elementContainer.isDataCollection" class="infinity pr-1" color="Blue"></icon>
      {{ elementContainer.referenceNameOrDefault }}
    </template>

    <template #section-contents>
      <field-item
          v-if="handler.allowElementContainerSelection"
          :disabled="handler.isDisabled(elementContainer, parentTreeContext)"
          @click="select(elementContainer)"
      >
        <row>
          <prefix>
            <icon :glyph="elementContainer.controlIcon" />
          </prefix>
          <column>
            {{ elementContainer.referenceNameOrDefault }}
          </column>
          <suffix v-if="elementContainer.isDataCollection">
            <icon glyph="infinity" color="Blue" />
          </suffix>
        </row>
      </field-item>

      <component :is="elementsSectionWrapperOrDiv" :id="`elementsCollapse_${elementContainer.client_id}-${dropdownControlId}`" :is-open="!hasSearched || isOpen(elementContainer.formElementsArray)">
        <template v-for="element in childElements.sort((a, b) => a.is_repeatable ? 1 : 0)">
          <form-element-container-data
            v-if="recurse && isLayoutElement(element)"
            :key="`element-container-${element.client_id}-${dropdownControlId}`"
            :handler="handler"
            :element-container="element"
            :parent-tree-context="childTreeContext({parent: elementContainer})"
            recurse
            @select="el => select(el)"
          />

          <field-item
              v-else
              :key="`element-container-${element.client_id}-${dropdownControlId}`"
              :disabled="handler.isDisabled(element, childTreeContext({parent: elementContainer}))"
              @click="select(element)"
          >
            <row>
              <prefix>
                <icon :glyph="element.controlIcon" />
              </prefix>
              <column>
                {{ element.referenceNameOrDefault }}
              </column>
              <suffix v-if="element.is_repeatable">
                <icon glyph="infinity" color="Blue" />
              </suffix>
            </row>
          </field-item>
        </template>
      </component>

      <slot name="after-elements" />
    </template>
  </collapsible-section>
</template>

<script lang="ts">
import Vue from 'vue';
import CollapsibleSection from './common/collapsible-section.vue';
import FormElementsSectionWrapper from './form-elements-section-wrapper.vue';
import FieldItem from './common/field-item.vue';
import FormElement from "../../../../formability/form_builder/models/formElements/formElement";
import {InstanceHelper} from "~/helpers/instanceHelper";
import {Capability} from "../../../../formability/form_builder/models/formElements/formElementCapability";
import dropdownControlMixin from '~/components/dynamicFieldsTrees/mixins/dropdownControlMixin'
import handlerTreeContextMixin from '~/components/dynamicFieldsTrees/mixins/handlerTreeContextMixin'
import {IDynamicTreeContext} from '~/interfaces/dynamicFieldsInterfaces'
import {IFormElementDynamicFieldHandler} from '~/interfaces/dynamicFieldsElementOptionsInterfaces'

export default Vue.extend({
  name: 'form-element-container-data',
  components: {
    CollapsibleSection,
    FormElementsSectionWrapper,
    FieldItem,
  },
  mixins: [
    dropdownControlMixin,
    handlerTreeContextMixin,
  ],
  props: {
    handler: {
      type: Object as () => IFormElementDynamicFieldHandler,
      required: true,
    },
    elementContainer: {
      type: Object as () => FormElement,
      required: true,
    },
    recurse: {
      type: Boolean,
      default: false,
    },
  },
  data: function (): object {
    return {
      hasSearched: false,
    };
  },
  computed: {
    elementsSectionWrapperOrDiv(): string {
      return this.handler.allowElementContainerSelection ? 'form-elements-section-wrapper': 'div';
    },
    childElements(): FormElement[] {
      return this.handler?.elementOptions?.getElements(this.elementContainer) || this.elementContainer.formElementsArray;
    },
    treeContext(): Partial<IDynamicTreeContext> {
      return {
        isTopLevelCollectionAssigned: this.parentTreeContext.isTopLevelCollectionAssigned || this.handler.isTopLevelCollection(this.elementContainer, this.parentTreeContext)
      }
    },
  },
  methods: {
    isLayoutElement(element: FormElement): boolean {
      return element.can(Capability.layoutContainer);
    },
    isOpen(item: Array<any> | boolean = null): boolean {
      if (!this.hasSearched) {
        return false;
      }
      return InstanceHelper.isPresent(item);
    },
    select(element: FormElement): void {
      this.$emit('select', element);
    },
  }
});
</script>